import { format } from 'd3-format';
export const num = format(',');
export const decimal = format(',.2f');
export const dollar = format('$,.2f');

const percentageFormatter = format('.0%');
const zeroPercFormatter = () => '0.0%';
export const percentage = n =>
  isNaN(n) ? zeroPercFormatter() : percentageFormatter(n);
